import axios from 'axios';
import { DashboardConfigurationInterface } from '../../models/DashboardConfiguration';
import { CloneStructure, SettingI } from './types';

export const DashboardConfigurationService = {
  cloneItemPOST: (data: CloneStructure) =>
    axios.post<any>(`/templatetasks/clone`, data),
  DashboardLevelGet: (params?: { id: string }) =>
    axios.get<DashboardConfigurationInterface[]>(`/DashboardLevel`, {
      params,
    }),
  DashboardLevelPost: (payload: {
    levelId: string;
    levelIndex: number;
    name: string;
    customerName: string;
    creatorName: string;
    dateTime: string;
    templateLevelId?: string;
  }) => axios.post(`/DashboardLevel`, payload),
  DashboardNextLevel: (params: { parentlevelId: string }) =>
    axios.get(`/DashboardLevel/nextLevel`, { params }),
  DashboardLevelDelete: (id: string) => axios.delete(`/DashboardLevel/${id}`),
  DashboardLevelEdit: (levelId: string, name: string) =>
    axios.put(`/DashboardLevel/levelName/${levelId}?name=${name}`),
  DashboardLevelIndexChange: (
    levelId: string,
    parentLevelId: string,
    index: number,
  ) =>
    axios.put(`/DashboardLevel/levelIndex/${levelId}`, null, {
      params: { parentLevelId, index },
    }),
  DashboardSettingPUT: (payload: SettingI) =>
    axios.put(`/DashboardLevel/setting/${payload?.levelId || ''}`, payload),
  DashboardSettingGET: (params: { levelId: string }) =>
    axios.get(`/DashboardLevel/setting/${params?.levelId || ''}`),
  GETMasterMetaData: (params: { masterId: string }) =>
    axios.get(
      `/MasterReport/MasterComponents?masterId=${params?.masterId || ''}`,
    ),
  MastertableDetailsGET: () => axios.get(`/DashboardLevel/setting/`),
};
